import createLucideIcon from '../createLucideIcon';

const Volume = createLucideIcon('Volume', [
  ['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5', key: '16drj5' }],
]);

export default Volume;
